import { AnimatePresence, motion } from "framer-motion";
import Particles from "./Particles";
import { LikeConfig } from "./config";
import { filledHeartVariants, outlineHeartVariants } from "./motion";
import { ClientOnly } from "@tanstack/react-router";
import { useHasLike, useLikePost } from "./hooks";

type TProps = {
  postId: number;
};
const PostLike = (props: TProps) => {
  const hasLike = useHasLike(props.postId);
  const likePost = useLikePost(props.postId);
  const title = "Поставить лайк";
  return (
    <button
      type="button"
      id="post-like-btn"
      aria-label={title}
      title={title}
      style={{
        pointerEvents: hasLike ? "none" : "auto",
        position: "relative",
      }}
      disabled={hasLike}
      onClick={likePost}
    >
      <motion.svg
        aria-hidden="true"
        viewBox="0 0 100 89"
        width={LikeConfig.heartSize}
        height={LikeConfig.heartSize}
        animate={hasLike ? "liked" : "empty"}
        whileTap="pressed"
      >
        <motion.path
          variants={outlineHeartVariants}
          fill="var(--heart-color)"
          d={LikeConfig.heartOutlinePath}
        />
        <motion.path
          variants={filledHeartVariants}
          fill="var(--heart-color)"
          d={LikeConfig.heartPath}
        />
      </motion.svg>
      <ClientOnly>
        <AnimatePresence>{hasLike && <Particles />}</AnimatePresence>
      </ClientOnly>
    </button>
  );
};
export default PostLike;
